import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function DatenschutzPage() {
  return <>
      <SEO title="Datenschutzerklärung" description="Datenschutzerklärung von CRMReview.de - Informationen zur Datenverarbeitung und Ihren Rechten" canonicalUrl="/datenschutz" data-id="element-187" />

      <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-188">
        {/* Navigation */}
        <nav className="border-b border-slate-200 bg-white sticky top-0 z-50" data-id="element-189">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-190">
            <Link to="/" className="font-bold text-xl tracking-tight hover:opacity-80 transition-opacity" data-id="element-191">
              CRM<span className="text-blue-600" data-id="element-192">Review</span>
              <span className="text-slate-400 font-normal" data-id="element-193">.de</span>
            </Link>
          </div>
        </nav>

        <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-194">
          <h1 className="text-3xl font-bold mb-8" data-id="element-195">Datenschutzerklärung</h1>

          <div className="space-y-12 text-slate-700 leading-relaxed" data-id="element-196">
            {/* Section 1 */}
            <section data-id="element-197">
              <h2 className="text-2xl font-bold text-slate-900 mb-6 pb-2 border-b border-slate-200" data-id="element-198">
                1. Datenschutz auf einen Blick
              </h2>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-199">
                Allgemeine Hinweise
              </h3>
              <p className="mb-4" data-id="element-200">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche
                Informationen zum Thema Datenschutz entnehmen Sie unserer unter
                diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-201">
                Datenerfassung auf dieser Website
              </h3>

              <h4 className="font-bold text-slate-900 mb-2" data-id="element-202">
                Wer ist verantwortlich für die Datenerfassung auf dieser
                Website?
              </h4>
              <p className="mb-4" data-id="element-203">
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                „Hinweis zur Verantwortlichen Stelle" in dieser
                Datenschutzerklärung entnehmen.
              </p>

              <h4 className="font-bold text-slate-900 mb-2" data-id="element-204">
                Wie erfassen wir Ihre Daten?
              </h4>
              <p className="mb-4" data-id="element-205">
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
                mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie
                in ein Kontaktformular eingeben.
              </p>
              <p className="mb-4" data-id="element-206">
                Andere Daten werden automatisch oder nach Ihrer Einwilligung
                beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                sind vor allem technische Daten (z. B. Internetbrowser,
                Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                dieser Daten erfolgt automatisch, sobald Sie diese Website
                betreten.
              </p>

              <h4 className="font-bold text-slate-900 mb-2" data-id="element-207">
                Wofür nutzen wir Ihre Daten?
              </h4>
              <p className="mb-4" data-id="element-208">
                Ein Teil der Daten wird erhoben, um eine fehlerfreie
                Bereitstellung der Website zu gewährleisten. Andere Daten können
                zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>

              <h4 className="font-bold text-slate-900 mb-2" data-id="element-209">
                Welche Rechte haben Sie bezüglich Ihrer Daten?
              </h4>
              <p className="mb-4" data-id="element-210">
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                Herkunft, Empfänger und Zweck Ihrer gespeicherten
                personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
                Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                können Sie diese Einwilligung jederzeit für die Zukunft
                widerrufen. Außerdem haben Sie das Recht, unter bestimmten
                Umständen die Einschränkung der Verarbeitung Ihrer
                personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
              <p className="mb-4" data-id="element-211">
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
                sich jederzeit an uns wenden.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-212">
                Analyse-Tools und Tools von Drittanbietern
              </h3>
              <p className="mb-4" data-id="element-213">
                Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
                ausgewertet werden. Das geschieht vor allem mit sogenannten
                Analyseprogrammen.
              </p>
              <p className="mb-4" data-id="element-214">
                Detaillierte Informationen zu diesen Analyseprogrammen finden
                Sie in der folgenden Datenschutzerklärung.
              </p>
            </section>

            {/* Section 2 */}
            <section data-id="element-215">
              <h2 className="text-2xl font-bold text-slate-900 mb-6 pb-2 border-b border-slate-200" data-id="element-216">
                2. Hosting
              </h2>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-217">
                Webflow
              </h3>
              <p className="mb-4" data-id="element-218">
                Wir hosten unsere Website bei Webflow. Anbieter ist die Webflow,
                Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA
                (nachfolgend Webflow). Wenn Sie unsere Website besuchen, erfasst
                Webflow verschiedene Logfiles inklusive Ihrer IP-Adressen.
              </p>
              <p className="mb-4" data-id="element-219">
                Webflow ist ein Tool zum Erstellen und zum Hosten von Websites.
                Webflow speichert Cookies oder sonstige
                Wiedererkennungstechnologien, die für die Darstellung der Seite,
                zur Bereitstellung bestimmter Webseitenfunktionen und zur
                Gewährleistung der Sicherheit erforderlich sind (notwendige
                Cookies).
              </p>
              <p className="mb-4" data-id="element-220">
                Details entnehmen Sie der Datenschutzerklärung von Webflow:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-221">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
              <p className="mb-4" data-id="element-222">
                Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6 Abs.
                1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
                möglichst zuverlässigen Darstellung unserer Website. Sofern eine
                entsprechende Einwilligung abgefragt wurde, erfolgt die
                Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit.
                a DSGVO und § 25 Abs. 1 TTDSG, soweit die Einwilligung die
                Speicherung von Cookies oder den Zugriff auf Informationen im
                Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des
                TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p className="mb-4" data-id="element-223">
                Die Datenübertragung in die USA wird auf die
                Standardvertragsklauseln der EU-Kommission gestützt. Details
                finden Sie hier:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-224">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
            </section>

            {/* Section 3 */}
            <section data-id="element-225">
              <h2 className="text-2xl font-bold text-slate-900 mb-6 pb-2 border-b border-slate-200" data-id="element-226">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-227">
                Datenschutz
              </h3>
              <p className="mb-4" data-id="element-228">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p className="mb-4" data-id="element-229">
                Wenn Sie diese Website benutzen, werden verschiedene
                personenbezogene Daten erhoben. Personenbezogene Daten sind
                Daten, mit denen Sie persönlich identifiziert werden können. Die
                vorliegende Datenschutzerklärung erläutert, welche Daten wir
                erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu
                welchem Zweck das geschieht.
              </p>
              <p className="mb-4" data-id="element-230">
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.
                B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen
                kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch
                Dritte ist nicht möglich.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-231">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="mb-4" data-id="element-232">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser
                Website ist:
              </p>
              <p className="mb-4 bg-slate-50 p-4 rounded border border-slate-200" data-id="element-233">
                Justus Kraft
                <br data-id="element-234" />
                Nebelhornstraße 15
                <br data-id="element-235" />
                87435 Kempten
                <br data-id="element-236" />
                Telefon: +49 174 5444423
                <br data-id="element-237" />
                E-Mail: jk@justus-kraft.de
              </p>
              <p className="mb-4" data-id="element-238">
                Verantwortliche Stelle ist die natürliche oder juristische
                Person, die allein oder gemeinsam mit anderen über die Zwecke
                und Mittel der Verarbeitung von personenbezogenen Daten (z. B.
                Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-239">
                Speicherdauer
              </h3>
              <p className="mb-4" data-id="element-240">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
                Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine
                Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
                gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe
                für die Speicherung Ihrer personenbezogenen Daten haben (z. B.
                steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                letztgenannten Fall erfolgt die Löschung nach Fortfall dieser
                Gründe.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-241">
                SSL- bzw. TLS-Verschlüsselung
              </h3>
              <p className="mb-4" data-id="element-242">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
                oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine
                SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
                erkennen Sie daran, dass die Adresszeile des Browsers von
                „http://" auf „https://" wechselt und an dem Schloss-Symbol in
                Ihrer Browserzeile.
              </p>
              <p className="mb-4" data-id="element-243">
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
                Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
                werden.
              </p>
            </section>

            {/* Section 4 */}
            <section data-id="element-244">
              <h2 className="text-2xl font-bold text-slate-900 mb-6 pb-2 border-b border-slate-200" data-id="element-245">
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-246">
                Cookies
              </h3>
              <p className="mb-4" data-id="element-247">
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies
                bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                löschen oder eine automatische Löschung durch Ihren Webbrowser
                erfolgt.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-248">
                Kontaktformular
              </h3>
              <p className="mb-4" data-id="element-249">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                werden Ihre Angaben aus dem Anfrageformular inklusive der von
                Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                Anfrage und für den Fall von Anschlussfragen bei uns
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
                weiter.
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-250">
                Anfrage per E-Mail, Telefon oder Telefax
              </h3>
              <p className="mb-4" data-id="element-251">
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird
                Ihre Anfrage inklusive aller daraus hervorgehenden
                personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            {/* Section 5 */}
            <section data-id="element-252">
              <h2 className="text-2xl font-bold text-slate-900 mb-6 pb-2 border-b border-slate-200" data-id="element-253">
                5. Plugins und Tools
              </h2>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-254">
                YouTube
              </h3>
              <p className="mb-4" data-id="element-255">
                Diese Website bindet Videos der Website YouTube ein. Betreiber
                der Website ist die Google Ireland Limited („Google"), Gordon
                House, Barrow Street, Dublin 4, Irland.
              </p>
              <p className="mb-4" data-id="element-256">
                Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in
                der Datenschutzerklärung von YouTube unter:{' '}
                <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-257">
                  https://policies.google.com/privacy?hl=de
                </a>
                .
              </p>

              <h3 className="text-lg font-bold text-slate-900 mb-3 mt-6" data-id="element-258">
                Google Web Fonts
              </h3>
              <p className="mb-4" data-id="element-259">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
                so genannte Web Fonts, die von Google bereitgestellt werden.
                Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
                Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
                anzuzeigen.
              </p>
            </section>
          </div>
        </main>

        <footer className="bg-slate-50 border-t border-slate-200 py-12 mt-12" data-id="element-260">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-slate-500 text-sm" data-id="element-261">
            <div className="flex justify-center space-x-6 mb-4" data-id="element-262">
              <Link to="/impressum" className="hover:text-slate-900" data-id="element-263">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-slate-900" data-id="element-264">
                Datenschutz
              </Link>
            </div>
            <p data-id="element-265">
              © {new Date().getFullYear()} CRMReview.de - Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}